// Avatar mapping for clusters
// Avatar images are located in ../assets/Microlearnings/Avatare/

// Avatar mapping for all clusters
export const AVATAR_MAPPING = {
    // Sicherheit & Ordnung (Traditionell, Nostalgisch‑Bürgerlich)
    "Sicherheit & Ordnung": {
      male: require('../assets/Microlearnings/Avatare/tra_male.png'),
      female: require('../assets/Microlearnings/Avatare/tra_female.png'),
      maleName: "Adam", 
      femaleName: "Amalia" 
    },
    
    // Status & Etablierung (Konservativ‑Gehoben)
    "Status & Etablierung": {
      male: require('../assets/Microlearnings/Avatare/kg_male.png'),
      female: require('../assets/Microlearnings/Avatare/kg_female.png'),
      maleName: "Heinrich",
      femaleName: "Catherine" 
    },
    
    // Leistung & Selbstoptimierung (Performer, Expeditiv, Adaptiv‑Pragmatische Mitte)
    "Leistung & Selbstoptimierung": {
      male: require('../assets/Microlearnings/Avatare/ap_male.png'),
      female: require('../assets/Microlearnings/Avatare/ap_female.png'),
      maleName: "Haseeb", 
      femaleName: "Sofia"
    },
    
    // Sinn & Verantwortung (Neo‑Ökologisch, Postmateriell)
    "Sinn & Verantwortung": {
      male: require('../assets/Microlearnings/Avatare/öko_male.png'),
      female: require('../assets/Microlearnings/Avatare/öko_female.png'),
      maleName: "Felix", 
      femaleName: "Stella" 
    },
    
    // Spaß & Erlebnis (Konsum‑Hedonistisch)
    "Spaß & Erlebnis": {
      male: require('../assets/Microlearnings/Avatare/kh_male.png'),
      female: require('../assets/Microlearnings/Avatare/kh_female.png'),
      maleName: "Mark", 
      femaleName: "Anjali" 
    },
    
    // Preis & Entlastung (Prekär)
    "Preis & Entlastung": {
      male: require('../assets/Microlearnings/Avatare/pre_male.png'),
      female: require('../assets/Microlearnings/Avatare/pre_female.png'),
      maleName: "Otto", 
      femaleName: "Leonie" 
    }
  };
  
  // Get avatar for a specific cluster
  export const getAvatarForCluster = (clusterName) => {
    return AVATAR_MAPPING[clusterName] || null;
  };
  
  // Check if avatars are available for a cluster
  export const hasAvatarForCluster = (clusterName) => {
    return clusterName in AVATAR_MAPPING && AVATAR_MAPPING[clusterName] !== null;
  };